module.exports = __webpack_public_path__ + "static/media/tudoSobreCiracaoVideoParaSeuNegocio.b8f04a52.png";